import * as React from 'react';
import {Box as MuiBox} from '@mui/material';
import {styled} from '@mui/system';
import Box from "../Common/Box";
import {useTheme} from "@mui/material/styles";

const StyledBox = styled(MuiBox)({
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    svg: {
        width: '100%',
        height: '100%',
    },
});

const ElvishGate: React.FC = () => {
    const theme = useTheme();

    return <StyledBox>
        <img
                style={{
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                    opacity: 0.1,
                    left: 0,
                    right: 0,
                }}
                alt={"gondor"}
                src={"/images/Escudo_Real_de_Gondor.svg"}/>
        <Box
                center
                sx={{
                    position: "absolute",
                    bottom: "100px",
                    padding: "10px",
                    marginTop: "-40px",
                    color: theme.palette.primary.main,
                    fontFamily: "monospace",
                    fontSize: "12px"
                }}
        >
            You seem to be in a strange place, Mellon.
        </Box>
    </StyledBox>;
}

export default ElvishGate;
